import React, { useState } from 'react';
import LoadingDialog from '../../components/LoadingDialog/LoadingDialog';
import {
  BackButton,
  PrimaryButton,
  PrimaryCheckbox,
  TextField,
} from '../../components/AtomComponents';
import useDataService from '../../hooks/useDataService';
import { eMessageType } from '../../types/IMessageType';
import apiToUrlMap from '../../ApiMapping';
import { useConfirm } from '../../context/ConfirmContext';

const GlobalSplashConfig = () => {
  const { confirm } = useConfirm();
  const [isLoading, setIsLoading] = useState(false);
  const [isCustomMessage, setIsCustomMessage] = useState(false);
  const [customMessage, setCustomMessage] = useState('');

  const { openSnackBar, fetchUrl } = useDataService();

  const splashPageHandler = async (operation: boolean) => {
    try {
      setIsLoading(true);

      let payload: { enable: boolean; customMessage?: string } = {
        enable: operation,
      };
      if (customMessage?.trim() && operation) payload.customMessage = customMessage.trim();

      const { Status } = await fetchUrl('POST', apiToUrlMap.globalSplashConfig, { body: payload });
      if (Status === 'Successful') {
        openSnackBar(
          `Splash page ${operation ? 'adde' : 'remove'}d successfully.`,
          eMessageType.success
        );
      } else {
        openSnackBar(`Failed to ${operation ? 'add' : 'remove'} splash page.`, eMessageType.error);
      }
    } catch (error) {
      openSnackBar('An error occurred. Please try again.', eMessageType.error);
    } finally {
      setIsLoading(false);
      setCustomMessage('');
      setIsCustomMessage(false);
    }
  };

  return (
    <div className="px-splash-config">
      <div className="cell small-6 medium-6 px-one-line-data">
        <LoadingDialog isDialogOpen={isLoading} />
        <BackButton />
        <h3 className="small-12">Global Splash Page Config</h3>
      </div>
      <p>
        <PrimaryCheckbox
          name="customMessage"
          checked={isCustomMessage}
          onChange={() => setIsCustomMessage((prevIsCustomMessage) => !prevIsCustomMessage)}
        />
        Custom Message
      </p>
      {isCustomMessage ? (
        <div className="margin-top-2 margin-bottom-2 cell small-6 tenant-select">
          <TextField
            label="Custom Message"
            size="small"
            value={customMessage}
            onChange={(e) => setCustomMessage(e.target.value)}
            className="margin-right-1"
            disabled={!isCustomMessage}
          />
        </div>
      ) : (
        <></>
      )}
      <div className="grid-x">
        <div className="margin-right-1 cell shrink">
          <PrimaryButton
            onClick={() => {
              confirm({
                onConfirm: () => splashPageHandler(true),
              });
            }}
          >
            ADD SPLASH PAGE
          </PrimaryButton>
        </div>
        <div className="margin-right-1 cell shrink">
          <PrimaryButton
            onClick={() => {
              confirm({
                onConfirm: () => splashPageHandler(false),
              });
            }}
          >
            REMOVE SPLASH PAGE
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default GlobalSplashConfig;
